module.exports = __webpack_public_path__ + "media/common/images/cta/mi-f6d1e260b193e71bc929f89c7570bb87.jpeg";